import { reduxActions as APP } from "_constants/app.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";

const mediaHelp = {
  [APP.MEDIA_HELP_STARTED]: (state) => ({
    ...state,
    mediaHelp: {
      ...state.mediaHelp,
      status: LOADING
    }
  }),
  
  [APP.MEDIA_HELP_SUCCESS]: (state, { payload }) => ({
    ...state,
    mediaHelp: {
      ...state.mediaHelp,
      data: payload?.data?.[0] ?? null,
      error: null,
      status: SUCCESS
    }
  }),

  [APP.MEDIA_HELP_FAIL]: (state, { payload }) => ({
    ...state,
    mediaHelp: {
      ...state.mediaHelp,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),

  [APP.MEDIA_HELP_SET]: (state, { payload }) => ({
    ...state,
    mediaHelp: {
      ...state.mediaHelp,
      data: payload?.data ?? null,
      error: null,
      status: SUCCESS
    }
  }),
};

export default mediaHelp;
